module.exports = __webpack_public_path__ + "static/media/image6.74cfc7b9.png";